if (!customElements.get('blog-pagination')) {
  customElements.define(
    'blog-pagination',
    class BlogPagination extends HTMLElement {
      connectedCallback() {
        const url = new URL(window.location.href);
        if (url.searchParams.has('page')) {
          url.searchParams.delete('page');
          window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        }

        this.items = [...this.querySelectorAll('[data-blog-page]')];
        this.controls = this.querySelector('[data-pagination-controls]');
        this.totalPages = this.items.reduce((max, item) => {
          const page = parseInt(item.getAttribute('data-blog-page'), 10);
          return page > max ? page : max;
        }, 1);
        this.currentPage = 1;

        if (this.items.length === 0 || this.totalPages < 2) return;

        this.controls?.addEventListener('click', (event) => {
          const pageButton = event.target.closest('[data-page-number]');
          if (pageButton && !pageButton.disabled) {
            event.preventDefault();
            this.showPage(parseInt(pageButton.getAttribute('data-page-number'), 10));
            return;
          }

          const previous = event.target.closest('[data-pagination-previous]');
          if (previous && !previous.disabled) {
            event.preventDefault();
            this.showPage(this.currentPage - 1);
            return;
          }

          const next = event.target.closest('[data-pagination-next]');
          if (next && !next.disabled) {
            event.preventDefault();
            this.showPage(this.currentPage + 1);
          }
        });

        this.showPage(1);
      }

      showPage(page) {
        if (page < 1 || page > this.totalPages) return;

        this.currentPage = page;

        this.items.forEach((item) => {
          item.hidden = parseInt(item.getAttribute('data-blog-page'), 10) !== page;
        });

        this.updateControls();

        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      updateControls() {
        if (!this.controls) return;

        const previous = this.controls.querySelector('[data-pagination-previous]');
        const next = this.controls.querySelector('[data-pagination-next]');

        if (previous) {
          previous.toggleAttribute('disabled', this.currentPage <= 1);
        }

        if (next) {
          next.toggleAttribute('disabled', this.currentPage >= this.totalPages);
        }

        this.controls.querySelectorAll('[data-page-number]').forEach((button) => {
          const page = parseInt(button.getAttribute('data-page-number'), 10);
          const isCurrent = page === this.currentPage;
          button.classList.toggle('current', isCurrent);
          button.toggleAttribute('disabled', isCurrent);
          button.setAttribute('aria-current', isCurrent ? 'page' : 'false');
        });
      }
    }
  );
}
